<template>
<div class="mic-level-meter">
  <div
    v-for="(level, i) in levels"
    :key="i"
    class="mic-level-bar"
    :style="{ height: barHeight(level), background: barColor(level) }"
  ></div>
</div>
</template>

<script>
// Reads levels off the shared SPEAK stream (micStream.js); a second
// getUserMedia tap would break the iOS-safe mic lifecycle.
import { subscribeLevels, unsubscribeLevels, BAR_COUNT } from '../../services/micStream';
const DIM = [63, 63, 70]; // between --field-hover and --faint
const GOLD = [252, 163, 17]; // --accent

function lerpColor(a, b, t) {
  const r = Math.round(a[0] + (b[0] - a[0]) * t);
  const g = Math.round(a[1] + (b[1] - a[1]) * t);
  const bl = Math.round(a[2] + (b[2] - a[2]) * t);
  return 'rgb(' + r + ',' + g + ',' + bl + ')';
}

export default {
  name: 'MicLevelMeter',
  data() {
    return {
      levels: new Array(BAR_COUNT).fill(0.04)
    };
  },
  mounted() {
    subscribeLevels(this.onLevels);
  },
  beforeDestroy() {
    unsubscribeLevels(this.onLevels);
  },
  methods: {
    onLevels(levels) {
      this.levels = levels.slice();
    },
    barHeight(level) {
      const h = Math.max(0.04, level || 0.04);
      return Math.round(8 + h * 92) + '%';
    },
    barColor(level) {
      const h = Math.max(0.04, level || 0.04);
      return lerpColor(DIM, GOLD, Math.min(1, h * 1.15));
    }
  }
};
</script>

<style scoped>
.mic-level-meter {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 30px;
  margin: 2px 0 10px;
  flex-shrink: 0;
}
.mic-level-bar {
  flex: 1 1 auto;
  min-width: 2px;
  max-width: 6px;
  border-radius: 2px;
  transition: height 0.11s ease-out, background-color 0.11s ease-out;
}
@media (max-height: 600px) {
  .mic-level-meter {
    height: 20px;
    margin: 0 0 6px;
  }
}
</style>
